module.exports = __webpack_public_path__ + "img/pump.3d1f4dc3.png";